import React from "react";
import { TransformedProfileData } from "@/types/publicProfile";

interface FooterSectionProps {
  profileData: TransformedProfileData;
}

export const FooterSection: React.FC<FooterSectionProps> = ({
  profileData,
}) => {
  return (
    <footer className="border-t border-gray-200/50 dark:border-gray-800/50 py-8 pb-32 bg-gray-50/30 dark:bg-gray-900/30">
      <div className="mx-auto max-w-6xl px-4 text-xs text-gray-500 dark:text-gray-400 md:px-6 lg:px-8 text-center">
        © 2025 Connectifyz • Portfolio v{profileData.metadata.version}
      </div>
    </footer>
  );
};
